'use client'

import { createContext } from 'react'
import { noop } from 'lodash'

import { UiState } from '@marketplace-web/shared/ui-state'
import { GenerateLabelModal } from '@marketplace-web/domain/conversation-shipping-data'

import {
  GetShippingLabelState,
  CollectionDatesState,
  DropOffTypeSelectionState,
  LabelTypeSelectionState,
  ActiveModalState,
  LabelOptionsState,
  DropOffPointTypeSelectionState,
} from './types'

export const initialCollectionDatesState: CollectionDatesState = {
  fetchCollectionDates: noop,
  uiState: UiState.Idle,
  collectionDates: undefined,
  selectedCollectionDate: undefined,
  availableCollectionDates: undefined,
  availableCollectionTimes: undefined,
  selectedCollectionTime: undefined,
  collectionDatesError: undefined,
  confirmedCollectionDate: undefined,
  confirmedCollectionTime: undefined,
  selectCollectionDate: noop,
  selectCollectionTime: noop,
  clearSelectedCollection: noop,
  confirmCollectionDateSelection: noop,
  clearCollectionDatesError: noop,
}

export const initialDropOffTypeSelectionState: DropOffTypeSelectionState = {
  selectedDropOffTypeKey: null,
  isSubmitEnabled: false,
  clearDropOffTypeSelection: noop,
  selectDropOffTypeKey: noop,
}

export const initialLabelTypeSelectionState: LabelTypeSelectionState = {
  isLabelTypeSubmitEnabled: false,
  selectLabelType: noop,
  clearLabelTypeSelection: noop,
  selectedLabelType: null,
}

export const initialActiveModalState: ActiveModalState = {
  activeModal: GenerateLabelModal.None,
  setActiveModal: noop,
}

export const initialLabelOptionsState: LabelOptionsState = {
  fetchLabelOptions: noop,
  labelOptions: undefined,
  clearLabelOption: noop,
  labelOptionsError: undefined,
  labelOptionsUiState: UiState.Idle,
}

export const initialDropOffPointTypeSelectionState: DropOffPointTypeSelectionState = {
  selectedDropOffPointType: null,
  selectDropOffPointType: noop,
  handleClearDropOffPointTypeSelection: noop,
  isDropOffPointTypeTypeSubmitEnabled: false,
}

export const initialState: GetShippingLabelState = {
  activeModal: initialActiveModalState,
  collectionDates: initialCollectionDatesState,
  dropOffTypeSelection: initialDropOffTypeSelectionState,
  labelTypeSelection: initialLabelTypeSelectionState,
  labelOptions: initialLabelOptionsState,
  dropOffPointTypeSelection: initialDropOffPointTypeSelectionState,
}

export type GetShippingLabelContextType = {
  state: GetShippingLabelState
}

const GetShippingLabelContext = createContext<GetShippingLabelContextType>({
  state: initialState,
})

export default GetShippingLabelContext
